export default __webpack_public_path__ + "static/media/modul-image-2.42ee937c.png";